import { userDuckCreator } from 'axl-ducks';
import { getPersonalizationClientEnv } from './duckUtils';
import inventoryDuck from './inventoryDuck';
import savedInventoryDuck from './savedInventoryDuck';

// Create the base userDuck
const baseUserDuck = userDuckCreator({
  inventoryDuck,
  savedInventoryDuck,
  ...getPersonalizationClientEnv(),
});

// The axl-ducks userDuck should have its own getPsxNotificationsCount selector
const userDuck = {
  ...baseUserDuck,
  selectors: {
    ...baseUserDuck.selectors,
    // Add our custom selector that adapts to our store structure
    getPsxNotificationsCount: (state) => {
      // Try the axl-ducks path first (state.user.psxNotificationsCount)
      if (baseUserDuck.selectors.getPsxNotificationsCount) {
        const axlResult = baseUserDuck.selectors.getPsxNotificationsCount(state);
        if (axlResult !== 0 && axlResult !== undefined) {
          return axlResult.toString();
        }
      }
      
      // Try our custom path
      const customResult = state?.buyerLandingPage?.user?.psxNotificationsCount || 0;
      return customResult.toString();
    },
  },
};

export default userDuck;
